export enum RouteParams {
  ProjectId = "projectId",
  GroupId = "groupId",
  UserId = "userId",
  FolderId = "folderId"
}
